<template>
  <BlockSection v-if="section" :section />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import BlockSection from '@backmarket/nuxt-layer-cms/BlockSection.vue'

import { useFetchFormattedCMSSections } from '~/scopes/cms/composables/useFetchFormattedCMSSections'

const props = defineProps<{
  index: 1 | 2 | 3 | 4 | 5
}>()
const { data: cmsSections } = useFetchFormattedCMSSections({ timeout: 2000 })

const section = computed(() => cmsSections.value?.[`section${props.index}`])
</script>
